class PaymentDetailsModel {
  constructor() {
    this.invoiceDueDays = 30;
    this.estimateValidTillDays = 30;
  }
}

export default PaymentDetailsModel;
